import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieCustomers($integrationId: Int, $page: Int, $search: String) {
    omieCustomers(integrationId: $integrationId, page: $page, limit: 30, search: $search) {
      nomeFantasia
      codigoClienteOmie
      codigoClienteIntegracao
      cnpjCpf
      razaoSocial
      codigoBanco
      agencia
      contaCorrente
      cnpjCpf
      nomeTitular
    }
  }
`

export const useCustomerSelectOmieLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieCustomers']))
      .then(data => {
        const result = data.map((item, index) => {
          return {
            id: index,
            name: item.nomeFantasia,
            razaoSocial: item.razaoSocial,
            cnpjCpf: item.cnpjCpf,
            codigoClienteIntegracao: item.codigoClienteIntegracao,
            codigoClienteOmie: item.codigoClienteOmie,
            codigoBanco: item.codigoBanco,
            agencia: item.agencia,
            contaCorrente: item.contaCorrente,
            cnpjCpf: item.cnpjCpf,
            nomeTitular: item.nomeTitular
          }
        })

        return result
      })
  }
}

const CustomerSelectOmie = ({ onChange, value, filter, ...props }) => {
  const getOptions = useCustomerSelectOmieLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default CustomerSelectOmie
